import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { throttle, reportActionToRedies, setShowSwiper, setbackData } from '../utils';
import { isBaiduMap, fetchData, getFloatWebUrl } from '../../../utils';
import { jsonp } from '@baidu/map-fe-utils';
import { btnListLikeBury, btnListCollectBury, btnListBottomCommentBury, btnListTextCommentBury, btnListFeedbackBury } from '../bury';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { isScreenOptimization } from '../abtestConfig.js';
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    shareObj: {
      type: Object,
      default: () => {
        return {};
      }
    },
    user_info: {
      type: Object,
      default: () => {
        return {};
      }
    },
    author: {
      type: Object,
      default: () => {
        return {};
      }
    },
    dataItem: {
      type: Object,
      default: () => {
        return {};
      }
    },
    index: {
      type: Number,
      default: 0
    },
    comment_num: {
      type: Number,
      default: 0
    },
    newBtnIcon: {
      type: Boolean,
      default: false
    },
    dataType: {
      type: String,
      default: 'feed'
    }
  },
  data() {
    return {
      favorite: {},
      like: {},
      subSource: '',
      tpFrom: '',
      commentData: [],
      userInfo: {},
      commentLength: 0,
      commentUpdatFlag: false,
      requireFlag: false,
      originLoginStatus: false,
      clickLike: false,
      clickCollect: false,
      // 是否是全民预警
      isForewarning: 0,
      stdTag: '',
      // 是否是权威账号
      isQwzh: 0,
      // push栏目
      pushCategory: '',
      isBaiduMap: isBaiduMap(),
      btnList: [],
      former_source: '',
      isScreenOptimization
    };
  },
  watch: {
    shareObj: {
      deep: true,
      immediate: true,
      handler(curr) {
        this.$nextTick(() => {
          const {
            favorite = {},
            like = {}
          } = curr || {};
          this.favorite = favorite || 0;
          this.like = like || 0;
          if (this.clickLike) {
            // 等待执行点赞
            this.originLoginStatus = true;
            if (this.like && this.like.liked) {
              this.clickLike = false;
              return;
            }
            const item = this.filterBtnItem(['like', 'want']);
            this.likeHandlerFunc(item);
          }
          if (this.clickCollect) {
            this.originLoginStatus = true;
            // 等待执行收藏
            if (this.favorite && this.favorite.status) {
              this.clickCollect = false;
              return;
            }
            const item = this.filterBtnItem(['collect', 'hasgo']);
            this.goCollect(item);
          }
        });
      }
    },
    comment_num(val) {
      this.btnList.forEach(item => {
        if (item.type === 'comment') {
          item.text = val || '评论';
        }
      });
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters({
    source: 'url/source',
    tplType: 'url/dataType',
    abtest: 'url/abtest'
  })), mapGetters('login', ['isLogin'])), mapGetters(['phoneInfo'])), {}, {
    newNumStyle() {
      return this.dataType === 'feed' && this.newBtnIcon && this.tpFrom !== 'push';
    },
    btnClass() {
      return type => {
        return {
          [`${type}`]: true,
          'like-active': this.like.liked,
          'collect-active': this.favorite.status
        };
      };
    },
    refreshBarStatus() {
      return this.isLogin && !this.originLoginStatus;
    }
  }),
  mounted() {
    const {
      tpSource = ''
    } = this.shareObj || {};
    this.tpFrom = tpSource;
    // 如果首屏无轮播图，或者为push无轮播图，则用组件的渲染时间作为首屏埋点
    if ((!setShowSwiper(this.dataItem, this.source) || this.tpFrom === 'push') && this.index === 0) {
      const endTime = Date.now();
      this.sendFirstScreenCostBury(endTime, true);
    }
    const {
      favorite = {},
      like = {},
      unique_id = '',
      subSource = '',
      isForewarning = 0,
      stdTag = '',
      uid = '',
      former_source = ''
    } = this.shareObj || {};
    this.favorite = favorite || 0;
    this.like = like || 0;
    this.originLoginStatus = favorite.isLogin;
    this.unique_id = unique_id || '';
    this.userInfo = this.user_info || {};
    this.subSource = subSource;
    this.isForewarning = isForewarning;
    this.stdTag = stdTag;
    this.uid = uid;
    const {
      author = {}
    } = this.dataItem || {};
    this.isQwzh = author.isQwzh || 0;
    this.pushCategory = author.pushCategory || '';
    this.former_source = former_source || '';
    this.setBtnList();
    this.commentShowPoint();
    this.handleLoadingHide();
    this.$bus.$on('btn-active-liked', val => {
      const {
        type,
        index
      } = val;
      if (index === this.index) {
        this.likeHandler(type);
      }
    });
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions({
    goLogin: 'login/goLogin',
    sendFirstScreenCostBury: 'firstScreen/sendFirstScreenCostBury',
    refreshBar: 'dataList/refreshBar',
    updateReqParams: 'dataList/updateReqParams'
  })), mapMutations({
    setFeedIndex: 'setFeedIndex',
    setShowLoading: 'setShowLoading'
  })), {}, {
    // 控制loading隐藏
    handleLoadingHide() {
      if (this.index === 1) {
        // 第二篇笔记开始渲染时隐藏loading
        this.$nextTick(() => {
          this.setShowLoading(false);
        });
      }
    },
    // 设置按钮列表
    setBtnList() {
      this.btnList = [this.getFeedback(), {
        text: '分享',
        handler: () => {
          this.handleShare(this.shareObj);
        },
        type: 'share'
      }, this.getLikeBtnInfo(), this.getCollectBtnInfo(), {
        text: this.comment_num || '评论',
        handler: this.showComment,
        type: 'comment'
      }].filter(item => {
        return item.text && item.text !== '';
      });
    },
    // 设置按钮底部标题数量
    likeNum(type = '') {
      let text = '';
      switch (type) {
        case 'like':
          text = this.formatNumber(this.like.num) || '点赞';
          break;
        case 'want':
          text = `${this.formatNumber(this.like.num)}人想去`;
          break;
        case 'hasgo':
          text = `${this.formatNumber(this.favorite.num)}人去过`;
          break;
        case 'collect':
          text = this.formatNumber(this.favorite.num) || '收藏';
          break;
        default:
          text = '';
          break;
      }
      return text;
    },
    // 设置点赞按钮&反馈按钮信息
    getLikeBtnInfo() {
      if (this.tpFrom === 'push') {
        return {
          text: '反馈',
          handler: this.reportHandler,
          type: 'report'
        };
      }
      const type = this.newBtnIcon ? 'want' : 'like';
      return {
        text: this.likeNum(type),
        handler: this.likeHandler,
        type: type
      };
    },
    // 设置收藏按钮信息
    getCollectBtnInfo() {
      const item = {
        handler: this.goCollect,
        type: '',
        text: ''
      };
      if (this.newNumStyle) {
        item.type = 'hasgo';
        item.text = this.likeNum('hasgo');
      } else if (this.dataType !== 'comment') {
        item.type = 'collect';
        item.text = this.likeNum('collect');
      }
      return item;
    },
    // 设置更多按钮
    getFeedback() {
      const item = {
        text: '更多',
        handler: this.showFeedback,
        type: 'feedback'
      };
      // 0是评论，1是笔记
      let {
        noteType
      } = this.dataItem;
      if (this.tplType === 'poicomment' && noteType === 0) {
        return item;
      }
      return {
        handler: this.showFeedback,
        type: '',
        text: ''
      };
    },
    toastMes(mes) {
      this.$toast({
        message: mes
      });
    },
    // 分享
    handleShare(shareObj) {
      if (!this.isBaiduMap) {
        this.$emit('open-Baidu-Map');
        return;
      }
      shareObj.index = this.index;
      this.$emit('open-share', shareObj);
      this.updateReqParams(this.dataItem);
      setbackData(true);
      return;
    },
    /**
    防止重复点击， 每隔 2000ms 点击一次
    */
    likeHandler: throttle(function (value) {
      // 上报action
      reportActionToRedies({
        unique_id: this.unique_id
      }, this.index, 'click_like', this.phoneInfo);
      if (!this.isBaiduMap) {
        this.$emit('open-Baidu-Map');
        return;
      }
      if (!this.isLogin) {
        this.goLogin();
        return;
      }
      if (this.like.liked && value === 'dbl') {
        this.$bus.$emit('like-anm-status', true);
        return;
      }
      this.updateReqParams(this.dataItem);
      setbackData(true);
      if (value === 'dbl') {
        // 双击轮播图点赞➕1
        value = this.filterBtnItem(['like', 'want']);
      }
      if (this.dataType === 'feed') {
        this.likeHandlerFunc(value);
      } else if (this.dataType === 'comment') {
        this.commentLike(value);
      }
    }, 1000, true),
    filterBtnItem(typeArr) {
      return this.btnList.find(item => typeArr.includes(item.type)) || {};
    },
    reportHandler() {
      this.$emit('push-report');
    },
    // 点赞埋点
    likePoint() {
      const params = {
        action: !this.like.liked,
        type: 'note',
        note_style: 'Micro',
        tp: this.tpFrom,
        pmgc: this.subSource,
        source: this.source,
        unique_id: this.unique_id,
        warningnote: this.isForewarning ? '1' : '0',
        authoritynote: this.isQwzh ? '1' : '0',
        pushcategory: this.pushCategory
      };
      btnListLikeBury(params);
    },
    /**
     * 评论转笔记点赞处理函数
     */
    commentLike(item) {
      const {
        cuid = ''
      } = this.phoneInfo || {};
      this.likePoint();
      const params = {
        key: '5DC0E90',
        type: 'comment',
        cuid,
        poi_uid: this.uid,
        unique_key: this.unique_id,
        cmt_id: this.dataItem.cmt_id || this.unique_id,
        like_num: this.like.num,
        jump_url: '',
        status: this.like.liked ? 2 : 1,
        former_source: this.former_source
      };
      fetchData('/search/cube/util/likeapi', {
        method: 'get',
        params
      }).then(res => {
        this.handleLikeNum(res, item);
      }).catch(err => {
        this.toastMes('操作失败，请稍后重试');
      });
    },
    /**
     * 点击喜欢按钮的处理函数-笔记
     */
    async likeHandlerFunc(item) {
      this.likePoint();
      if (this.refreshBarStatus) {
        this.handleRefreshBar('clickLike');
      } else {
        const urlType = this.like.liked ? 'remove' : 'add';
        const param = _objectSpread(_objectSpread({}, this.phoneInfo), {}, {
          service: this.like.service,
          fid: this.like.fid,
          stoken: this.like.stoken
        });

        // 线上地址
        const baseUrl = 'https://newclient.map.baidu.com';
        // 测试地址
        // const baseUrl = 'http://yq01-bce-ais-duer-online-041.yq01.baidu.com:8015';
        let url = baseUrl + '/userfav/like/' + urlType;
        jsonp(url, param).then(res => {
          res.code = res.errno;
          this.handleLikeNum(res, item);
        });
      }
    },
    // 点赞后数量更新
    handleLikeNum(res, item) {
      const {
        code
      } = res || {};
      if (+code === 0) {
        this.like.liked = !this.like.liked;
        if (this.like.liked) {
          if (this.dataType === 'feed') {
            this.$bus.$emit('like-anm-status', true);
          }
          ++this.like.num;
        } else {
          --this.like.num;
        }
        if (this.dataType === 'feed') {
          this.like.toast = true;
          const ToastTimerLike = setTimeout(() => {
            this.like.toast = false;
            clearTimeout(ToastTimerLike);
          }, 2000);
        }
        this.setItemNum(item);
      } else if (code === 6005) {
        this.toastMes('操作太频繁，请稍后重试');
      } else {
        this.toastMes('操作失败，请稍后重试');
      }
    },
    // 笔记收藏接口
    goCollect: throttle(function (item) {
      // 上报action
      reportActionToRedies({
        unique_id: this.unique_id
      }, this.index, 'click_collect', this.phoneInfo);
      if (!this.isBaiduMap) {
        this.$emit('open-Baidu-Map');
        return;
      }
      if (!this.isLogin) {
        this.goLogin();
        return;
      }
      btnListCollectBury({
        action: !this.favorite.status,
        type: 'note',
        note_style: 'Micro',
        tp: this.tpFrom,
        pmgc: this.subSource,
        source: this.source || 'feed',
        warningnote: this.isForewarning ? '1' : '0',
        unique_id: this.unique_id,
        authoritynote: this.isQwzh ? '1' : '0',
        pushcategory: this.pushCategory
      });
      this.updateReqParams(this.dataItem);
      setbackData(true);
      if (this.isLogin && !this.originLoginStatus) {
        this.handleRefreshBar('clickCollect');
      } else {
        const urlType = this.favorite.status ? 'remove' : 'add';
        const param = _objectSpread(_objectSpread({}, this.phoneInfo), {}, {
          service: this.favorite.service,
          fid: this.favorite.fid,
          stoken: this.favorite.stoken
        });
        const baseUrl = 'https://newclient.map.baidu.com';
        let url = baseUrl + '/userfav/rich/' + urlType;
        jsonp(url, param).then(res => {
          const {
            errno,
            data
          } = res || {};
          // errno：0：表示成功
          if (errno === 0) {
            this.favorite.status = !this.favorite.status;
            if (this.favorite.status) {
              this.favorite.num = this.favorite.num ? Number(this.favorite.num) + 1 : 1;
            } else {
              this.favorite.num = Number(this.favorite.num) - 1;
            }
            this.favorite.toast = true;
            const ToastTimer = setTimeout(() => {
              this.favorite.toast = false;
              clearTimeout(ToastTimer);
            }, 2000);
            this.setItemNum(item);
          } else if (errno === 6005) {
            this.toastMes('操作太频繁，请稍后重试');
          } else {
            this.toastMes('操作失败，请稍后重试');
          }
        });
      }
    }, 1000, true),
    // 更新收藏点赞数量
    setItemNum(item = {}) {
      item.text = this.likeNum(item.type);
    },
    handleRefreshBar(type) {
      this.refreshBar(this.index, this.unique_id);
      this[type] = true;
    },
    // 处理点赞、收藏数的函数
    formatNumber(value) {
      // todo 逻辑待优化
      if (!value) {
        return 0;
      }
      if (value < 1000) {
        return value.toString();
      } else if (value >= 1000 && value <= 9999) {
        return (value / 1000).toFixed(1) + 'k';
      } else if (value >= 10000) {
        return (value / 10000).toFixed(1) + 'w';
      }
    },
    // 点击评论btn跳转到蒙层
    async showComment() {
      // 上报action
      reportActionToRedies({
        unique_id: this.unique_id
      }, this.index, 'click_comment', this.phoneInfo);
      if (!this.isBaiduMap) {
        this.$emit('open-Baidu-Map');
        return;
      }
      this.updateReqParams(this.dataItem);
      setbackData(true);
      btnListBottomCommentBury({
        tp: this.tpFrom,
        Feed_id: this.unique_id,
        std_tag: this.stdTag,
        poi_uid: this.uid,
        note_style: 'Micro',
        warningnote: this.isForewarning ? '1' : '0',
        authoritynote: this.isQwzh ? '1' : '0',
        pushcategory: this.pushCategory
      });
      const hostname = getFloatWebUrl();
      let targetUrl = `https://${hostname}/feed-h5/micro-detail-panel?tplType=article&showComment=1` + `&stdTag=${encodeURIComponent(this.stdTag)}&tpSource=${this.tpFrom}`;
      // 点击评论跳转到蒙层前更新当前index
      this.setFeedIndex(Number(this.index));
      if (this.dataType === 'comment') {
        const {
          bid = '',
          cmt_id = '',
          uid: poi_uid = '',
          origin_user_info = {},
          actionBar = {}
        } = this.dataItem || {};
        const {
          user_name = '',
          user_id = ''
        } = origin_user_info || {};
        const {
          author: {
            contentSource = ''
          } = {}
        } = actionBar || {};
        const is_rich = contentSource === 'rec_comment' ? 1 : 0;
        targetUrl = targetUrl + `&dataType=comment&bid=${bid}&user_id=${user_id}&user_name=${encodeURIComponent(user_name)}` + `&cmt_id=${cmt_id}&poi_uid=${poi_uid}&isComment=1&is_rich=${is_rich}`;
      } else {
        targetUrl = targetUrl + `&dataType=feed&unique_id=${this.unique_id}`;
      }
      const url = encodeURIComponent(targetUrl);
      window.location.href = 'baidumap://map/floatweb?action=open&popRoot=no&attachToPage=true&popStyle=1&url=' + url;
    },
    /**
     * 评论展示埋点
     */
    commentShowPoint() {
      this.$nextTick(() => {
        const commentRef = this.$refs.comment;
        commentRef && this.$io.observe(commentRef[0], () => {
          btnListTextCommentBury({
            tp: this.tpFrom,
            Feed_id: this.unique_id,
            std_tag: this.stdTag,
            poi_uid: this.uid
          });
        });
      });
    },
    // 点击更多跳转到蒙层
    showFeedback() {
      if (!this.isBaiduMap) {
        this.$emit('open-Baidu-Map');
        return;
      }
      btnListFeedbackBury();
      const hostname = getFloatWebUrl();
      let targetUrl = `https://${hostname}/feed-h5/feedback-panel?tplType=article&showFeedback=1`;
      const {
        author = {},
        cmt_id = '',
        uid: poi_uid = '',
        former_source = '',
        unique_id = ''
      } = this.dataItem || {};
      const {
        name: user_name = ''
      } = author || {};
      const {
        cuid = '',
        os = '',
        sv = ''
      } = this.phoneInfo || {};
      targetUrl = targetUrl + `&dataType=comment&&former_source=${former_source}&user_name=${encodeURIComponent(user_name)}` + `&cmt_id=${cmt_id}&poi_uid=${poi_uid}&isComment=1&unique_id=${unique_id}&cuid=${cuid}&os=${os}&sv=${sv}`;
      const url = encodeURIComponent(targetUrl);
      window.location.href = 'baidumap://map/floatweb?action=open&popRoot=no&attachToPage=true&popStyle=1&url=' + url;
    }
  }),
  destroyed() {
    this.$bus.$off('btn-active-liked', this.likeHandler);
  }
};